export interface Note {
  first_name: string,
  last_name: string,
  comment: string,
  creation_date: string,
  isOldComment: boolean,
};

export type Participation = {
  id: string
  created_at: string
  updated_at: string
  last_reminded_at: string
  organization_id: string
  campaign_id: string
  member_id: string
  assessment_id: string
  comments: Note[]
  approved: boolean
}

export enum StreamingSessionError {
  PARTICIPATION_COMPLETED = 'PARTICIPATION_COMPLETED',
  SITUATION_NOT_IN_PARTICIPATION = 'SITUATION_NOT_IN_PARTICIPATION',
  SITUATION_COMPLETED = 'SITUATION_COMPLETED',
  SITUATION_NOT_CONFIGURED = 'SITUATION_NOT_CONFIGURED',
  RESOLUTION_FAILED = 'RESOLUTION_FAILED',

}

export type StreamingSessionResponse =
  | { type: "session_already_started" | "session_ready", pixel_streaming_url: string }
  | { type: "no_response_yet" }
  | { type: "no_capacity_for_conversation" }
  | { type: "conversation_launch_error", reason: StreamingSessionError };

export type ConversationStatusResponse =
  | { type: "no_response_yet" }
  | { type: "sidecar_conversation_ended" }
  | { type: "conversation_error", message: string };
